import { render } from "./editCompositionPercentageModal.vue?vue&type=template&id=5f8423d5&scoped=true&ts=true"
import script from "./editCompositionPercentageModal.vue?vue&type=script&lang=ts"
export * from "./editCompositionPercentageModal.vue?vue&type=script&lang=ts"

import "./editCompositionPercentageModal.vue?vue&type=style&index=0&id=5f8423d5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8423d5"]])

export default __exports__